import { EVMAnalyticsEvent } from "@aix/vidmax-shared/src/analytics"
import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"
import { ProductPricingTable } from "~/components/Pricing/ProductPricingTable"
import { ADS_PLATFORM_PRICING_CONFIG } from "~/config/pricing"
import MarketingPricingFAQ from "~/components/Marketing/MarketingPricingFAQ"
import MarketingLayout from "~/layouts/MarketingLayout"
import CustomHead from "~/components/SEOHead/CustomHead"
import { usePH } from "~/utils/posthogClient"
import { getPageSEO } from "~/utils/seo"

export const Route = createFileRoute("/pricing")({
  component: PricingPage,
})

function PricingPage() {
  const pricingSEO = getPageSEO("pricing")
  const { capture } = usePH()

  useEffect(() => {
    capture(EVMAnalyticsEvent.PRICING_PAGE_VIEWED, { source: "direct" })
  }, [capture])

  return (
    <MarketingLayout>
      <CustomHead
        title={pricingSEO.title}
        description={pricingSEO.description}
        keywords={pricingSEO.keywords}
        pageType={pricingSEO.pageType}
        url="https://vidmax.ai/pricing"
      />

      <ProductPricingTable config={ADS_PLATFORM_PRICING_CONFIG} />
      <MarketingPricingFAQ className="mb-20" />
    </MarketingLayout>
  )
}
